import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "navbar navbar-expand-lg mb-3" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = {
  key: 0,
  class: "navbar-nav me-auto mb-2 mb-lg-0"
}
const _hoisted_7 = {
  key: 1,
  class: "me-auto mb-2 mb-lg-0"
}
const _hoisted_8 = { class: "navbar-text" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex flex-row align-items-center text-nowrap"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "sr",
  selected: ""
}, "Српски", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "ru" }, "Русский", -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "form-check form-switch" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "darkModeSwitch" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-moon" })
], -1)

import { onMounted, reactive, ref } from "vue";
import NavbarRoute from "@/components/NavbarRoute.vue";
import { setLocale } from "@/services/localisation";
import { useTranslate } from "@/hooks/translate.hook";
import { LocationModel } from "@/models/location.model";
import { MainService } from "@/services/main.service";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation',
  props: {
  show: {
    type: Boolean,
    default: true,
    required: false
  },
  logo: {
    type: Boolean,
    default: true,
    required: false
  }
},
  setup(__props) {

const t = useTranslate()
const route = useRoute()

const tutor = process.env.VUE_APP_MTUTOR_NAME
const color = reactive({
  color: process.env.VUE_APP_MTUTOR_COLOR
})

// Handle language in URL
if (route.query.lang) {
  const queryLang = route.query.lang as string
  if (queryLang === "sr" || queryLang === "en" || queryLang === "ru") {
    localStorage.setItem('language', queryLang)
    setLocale(queryLang)
  }
}

const lang = ref<string>(localStorage.getItem('language') ?? 'sr')

function handleLangChange() {
  setLocale(lang.value)
}

const props = __props

const location = ref<LocationModel>()
if (props.show) {
  MainService.getCurrentLocation().then(rsp => {
    location.value = rsp.data
  })
}

const darkMode = ref<boolean>(false);

onMounted(() => {
  const savedMode = localStorage.getItem('darkMode');
  if (savedMode !== null) {
    darkMode.value = JSON.parse(savedMode);
  } else {
    // Default dark mode
    darkMode.value = true
  }
  toggleDarkMode(); // Apply the mode when the component is mounted
});

const toggleDarkMode = () => {
  document.documentElement.setAttribute('data-bs-theme', (darkMode.value) ? 'dark' : 'light')
  localStorage.setItem('darkMode', JSON.stringify(darkMode.value));
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.logo)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            class: "navbar-brand",
            to: (props.show) ? '/' : '#'
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (props.show)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              _createVNode(NavbarRoute, {
                name: _unref(t)('navigation.list'),
                to: "/list"
              }, null, 8, ["name"]),
              _createVNode(NavbarRoute, {
                name: _unref(t)('navigation.setup'),
                to: "/setup"
              }, null, 8, ["name"]),
              _createVNode(NavbarRoute, {
                name: _unref(t)('navigation.results'),
                to: "/results"
              }, null, 8, ["name"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7)),
        _createElementVNode("div", _hoisted_8, [
          (_unref(tutor))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("i", {
                  class: "fa-solid fa-circle pe-1",
                  style: _normalizeStyle(color)
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(_unref(tutor)), 1),
                (location.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (" + _toDisplayString(location.value.name) + ")", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "aria-label": "Default select example",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((lang).value = $event)),
            onChange: handleLangChange
          }, _hoisted_14, 544), [
            [_vModelSelect, lang.value]
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              id: "darkModeSwitch",
              type: "checkbox",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((darkMode).value = $event)),
              onChange: toggleDarkMode
            }, null, 544), [
              [_vModelCheckbox, darkMode.value]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})